import { render, staticRenderFns } from "./ActionRequests.vue?vue&type=template&id=3f197622"
import script from "./ActionRequests.vue?vue&type=script&lang=js"
export * from "./ActionRequests.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports